export function activateActions (parentElement, gridApi) {
  // console.log('activateActions', parentElement)
  const elementsWithExport = parentElement.querySelector('[d-action="exportTable"]')
  activateExport(elementsWithExport, gridApi)
}

function activateExport (element, gridApi) {
  // console.log('activateExport', element)
  element.addEventListener('click', function () {
    if (!gridApi.exportDataAsCsv) return

    gridApi.exportDataAsCsv({
      skipPinnedTop: true
    })
  })
}
